import { useEffect } from 'react';
import { templateTagGroupApi } from '../../../../../../../entities/template/private-template-tag-group';

export const usePrivateTemplateGroupTags = (groupId: string | undefined) => {
	const { data: tagsData, refetch: refetchTags } = templateTagGroupApi.useGetTemplateGroupsQuery({
		page: 1,
		limit: 127,
		search: '',
	});

	useEffect(() => {
		refetchTags();
	}, [groupId]);

	return { tagsData };
};
